var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.546875 6.07812C0.382812 5.91406 0.382812 5.61328 0.546875 5.44922L5.79688 0.199219C5.96094 0.0351562 6.26172 0.0351562 6.42578 0.199219C6.58984 0.363281 6.58984 0.664062 6.42578 0.828125L1.47656 5.75L6.42578 10.6992C6.58984 10.8633 6.58984 11.1641 6.42578 11.3281C6.26172 11.4922 5.96094 11.4922 5.79688 11.3281L0.546875 6.07812Z",
    fill: "#082940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowLogo);
export default __webpack_public_path__ + "static/media/leftArrowLogo.314405a3c304f4741a86c17c17c03429.svg";
export { ForwardRef as ReactComponent };